module.exports = __webpack_public_path__ + "static/media/routing.10c5f88a.png";